<template>
    <div id="filter_advanced">
        <div class="ui form" @keypress.enter="$parent.$parent.operations_filter()">
            <div class="three fields">
                <div class="field">
                    <label>{{ $t('models.attributes.operations.created_at') }}</label>
                    <DatePicker
                        v-model="filter.columns.created_duration"
                        format="YYYY-MM-DD"
                        type="daterange"
                        key="advanced_created_at"
                        :re_init="Boolean(filter.columns.created_duration)"
                    >
                    </DatePicker>

                    <!-- <el-date-picker
                        style="width: 100%;"
                        v-model="filter.columns.created_duration"
                        unlink-panels
                        type="daterange"
                        align="center"
                        :start-placeholder="$t('ui.el.datepicker.startDate')"
                        :end-placeholder="$t('ui.el.datepicker.endDate')"
                        :picker-options="$store.state.element_ui_datepicker_daterange_options"
                        >
                    </el-date-picker> -->
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.operations.number') }}</label>
                    <input type="text"
                        v-model="filter.columns.number"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.operations.customer_identity') }}</label>
                    <div class="ui selection fluid dropdown" v-dropdown>
                        <div class="text"
                            v-for="customer in customers"
                            v-if="filter.columns.customer_identity == customer.identity">
                            {{ customer.company_name }}
                        </div>
                        <i class="dropdown icon"></i>
                        <div class="menu">
                            <div
                                v-for="customer in customers"
                                @click="filter.columns.customer_identity = customer.identity"
                                class="item"
                                :class="{
                                    'selected active': filter.columns.customer_identity == customer.identity
                                }">
                                {{ customer.company_name }}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="four fields">
                <div class="field">
                    <label>{{ $t('models.attributes.operations.provider_note') }}</label>
                    <input type="text"
                        v-model="filter.columns.provider_note"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.operations.customer_note') }}</label>
                    <input type="text"
                        v-model="filter.columns.customer_note"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.operations.original_file_name') }}</label>
                    <input type="text"
                        v-model="filter.columns.original_file_name"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.operations.status') }}</label>
                    <div class="ui checkbox" v-checkbox>
                        <input type="checkbox" v-model="filter.columns.is_done">
                        <label>{{ $t('models.attributes.operations.is_done') }}</label>
                    </div>
                    <div class="ui checkbox" v-checkbox>
                        <input type="checkbox" v-model="filter.columns.is_canceled">
                        <label>{{ $t('models.attributes.operations.is_canceled') }}</label>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="ui icon blue button right floated"
            @click="$parent.$parent.operations_filter()">
            <i class="search icon"></i>
            {{ $t('ui.general.search') }}
        </div>
        <div class="clear">

        </div>
    </div>
</template>

<script>
import DatePicker from "@toolbox/date_picker/main.vue"

export default {
    name: "OperationsFilterAdvanced",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.operations_module
        },
        filter() {
            return this.current_store.filter
        },
        customers() {
            return [{
                company_name: this.$t('ui.general.please_select'),
                identity: null,
            }].concat(this.$store.state.provider.customers)
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
        DatePicker
    }
}
</script>
